( function( $ ) {
	'use strict';

	$( function() {
		const activeClass = 'is-active';
		const offcanvasActiveClass = 'site-offcanvas--is-active';

		const $item = $( '.js-offcanvas-menu-item' );
		const $trigger = $( '.js-offcanvas-menu-trigger' );
		const $submenu = $( '.js-offcanvas-menu-submenu' );
		const $offcanvas = $( '.js-site-offcanvas' );

		$trigger.on( 'click', function( event ) {
			event.preventDefault();
			$( this ).toggleClass( activeClass );
			$( this ).parent().find( $submenu ).first().slideToggle();
		} );

		$( $submenu ).find( 'a' ).not( $trigger ).on( 'click', function() {
			$offcanvas.removeClass( offcanvasActiveClass );
		} );
	} );
} )( jQuery );
